import React from "react";
import Hero from "../components/Hero";
import { SliderDataTwo } from "../data/SliderData";

const Rentals = () => {
  return <Hero slides={SliderDataTwo} />;
};

export default Rentals;
